import { useQuery } from '@tanstack/react-query';

import fetchConsent from '../../services/consent';

export default function useFetchConsent({ enabled = true }: { enabled?: boolean }) {
  return useQuery({
    queryKey: ['consent'],
    queryFn: fetchConsent,
    enabled,
  });
}
